export default __webpack_public_path__ + "static/media/fa-brands-400.04f5ae71.svg";